const reverseEasing = (easing) => (p) => 1 - easing(1 - p);
export {
  reverseEasing
};
